import { SectionLoader } from '@/shared/components/section-loader';

export const TrackerLoading = () => {
  return <SectionLoader />;
};
